export default __webpack_public_path__ + "static/media/håp-fremtid.179d8f7c.jpg";